import {
  Activity as ActivityIcon,
  Codesandbox as CodesandboxIcon,
  User as UserIcon,
  MapPin as MapPinIcon,
  PieChart as PieChartIcon,
  Home as HomeIcon,
  Upload as UploadIcon,
  FilePlus as FilePlus,
  Archive as Archive,
  Clipboard as ClipBoardIcon,
  File as FileIcon,
  // Briefcase as BriefcaseIcon,
  // Calendar as CalendarIcon,
  // ShoppingCart as ShoppingCartIcon,
  // Folder as FolderIcon,
  // BarChart as BarChartIcon,
  // Lock as LockIcon,
  // UserPlus as UserPlusIcon,
  // Shield as ShieldIcon,
  // AlertCircle as AlertCircleIcon,
  // Trello as TrelloIcon,
  // Layout as LayoutIcon,
  // Edit as EditIcon,
  // DollarSign as DollarSignIcon,
  // Mail as MailIcon,
  // MessageCircle as MessageCircleIcon,
  // Share2 as ShareIcon,
  // Users as UsersIcon,
  List as ListIcon,
  Rss as RssIcon
} from 'react-feather';


/* eslint-disable import/prefer-default-export */
export const THEMES = {
  LIGHT: 'LIGHT',
  ONE_DARK: 'ONE_DARK',
  UNICORN: 'UNICORN'
};



export const custMenu = [
  {
    rolNeed: 6,
    subheader: 'customMenu.navBar.home.title',
    href: 'customMenu.navBar.home.href',
    items: [
      {
        title: 'customMenu.navBar.home.landing.title',
        icon: HomeIcon,
        href: 'customMenu.navBar.home.landing.href'
      }
    ]
  },
  {
    subheader: 'customMenu.navBar.general.title',
    items: [
      {
        rolNeed: 1,
        title: 'customMenu.navBar.general.pedidos.list.title',
        icon: ListIcon,
        href: 'customMenu.navBar.general.pedidos.list.href'
      },
      {
        rolNeed: 2,
        title: 'customMenu.navBar.general.pedidos.list.title',
        icon: ListIcon,
        href: 'customMenu.navBar.general.pedidos.list.href'
      },
      {
        rolNeed: 3,
        title: 'customMenu.navBar.general.pedidos.list.title',
        icon: ListIcon,
        href: 'customMenu.navBar.general.pedidos.list.href'
      },
      {
        rolNeed: 4,
        title: 'customMenu.navBar.general.pedidos.list.title',
        icon: ListIcon,
        href: 'customMenu.navBar.general.pedidos.list.href'
      },
      {
        rolNeed: 5,
        title: 'customMenu.navBar.general.pedidos.list.title',
        icon: ListIcon,
        href: 'customMenu.navBar.general.pedidos.list.href'
      },
      {
        rolNeed: 1,
        title: 'customMenu.navBar.general.pedidos.new.title',
        icon: UploadIcon,
        href: 'customMenu.navBar.general.pedidos.new.href'
      },
      {
        rolNeed: 3,
        title: 'customMenu.navBar.general.pedidosLab.new.title',
        icon: UploadIcon,
        href: 'customMenu.navBar.general.pedidosLab.new.href'
      },
      {
        rolNeed: 2,
        title: 'customMenu.navBar.general.pedidos.new.title',
        icon: UploadIcon,
        href: 'customMenu.navBar.general.pedidos.new.href'
      },
      {
        rolNeed: 5,
        title: 'customMenu.navBar.general.pedidosFAR.new.title',
        icon: UploadIcon,
        href: 'customMenu.navBar.general.pedidosFAR.new.href'
      },
      {
        rolNeed: 3,
        title: 'customMenu.navBar.general.pedidosLabEspecial.new.title',
        icon: UploadIcon,
        href: 'customMenu.navBar.general.pedidosLabEspecial.new.href'
      },
      {
        rolNeed: 4,
        title: 'customMenu.navBar.general.pedidosCC.new.title',
        icon: UploadIcon,
        href: 'customMenu.navBar.general.pedidosCC.new.href'
      },
      {
        rolNeed: 2,
        title: 'customMenu.navBar.general.documentos.title',
        icon: ActivityIcon,
        href: 'customMenu.navBar.general.documentos.href'
      },
      {
        rolNeed: 3,
        title: 'customMenu.navBar.general.documentos.title',
        icon: ActivityIcon,
        href: 'customMenu.navBar.general.documentos.href'
      },
      {
        rolNeed: 5,
        title: 'customMenu.navBar.general.documentosFarma.title',
        icon: ActivityIcon,
        href: 'customMenu.navBar.general.documentosFarma.href'
      },
      {
        rolNeed: 6,
        title: 'customMenu.navBar.general.devolucion.list.title',
        icon: ListIcon,
        href: 'customMenu.navBar.general.devolucion.list.href'
      },
      {
        rolNeed: 6,
        title: 'customMenu.navBar.general.devolucion.new.title',
        icon: UploadIcon,
        href: 'customMenu.navBar.general.devolucion.new.href'
      },
      {
        rolNeed: 5,
        title: 'customMenu.navBar.general.descargaDeTemplates.new.title',
        icon: FileIcon,
        href: 'customMenu.navBar.general.descargaDeTemplates.new.href'
      },
      {
        rolNeed: 5,
        title: 'customMenu.navBar.general.cargaDeDocumentos.new.title',
        icon: FilePlus,
        href: 'customMenu.navBar.general.cargaDeDocumentos.new.href'
      }
    ]
  }
  // ,
  // {
  //   subheader: 'customMenu.navBar.management.title',
  //   items: [
  //     {
  //       title: 'dashboardLayout.navBar.sub_pages.account.title',
  //       href: 'dashboardLayout.navBar.sub_pages.account.href',
  //       icon: UserIcon
  //     }
  //     // ,
  //     // {
  //     //   title: 'customMenu.navBar.management.abm.title',
  //     //   icon: ListIcon,
  //     //   href: 'customMenu.navBar.management.abm.href',
  //     //   items: [
  //     //     {
  //     //       rolNeed: 1,
  //     //       title: 'customMenu.navBar.management.abm.users.title',
  //     //       href: 'customMenu.navBar.management.abm.users.href'
  //     //     }
  //     //   ]
  //     // }
  //   ]
  // }
];
